import PropTypes from "prop-types";

import { SVG } from "../../components";
import { CheckboxLabel, CheckmarkWrapper } from "./styled";

const Checkbox = ({ id, checked, partiallyChecked = false, onCheck, disabled }) => {
  return (
    <CheckboxLabel disabled={disabled} onClick={(e) => onCheck(e)}>
      <input id={id} type="checkbox" />
      <span
        className={`checkbox ${checked || partiallyChecked ? "checkbox--active" : ""}`}
        aria-hidden="true"
        data-testid="checkbox">
        <CheckmarkWrapper checked={checked} partiallyChecked={partiallyChecked}>
          {checked && <SVG.CheckIcon />}
          {partiallyChecked && !checked && <SVG.DashIcon />}
        </CheckmarkWrapper>
      </span>
    </CheckboxLabel>
  );
};

Checkbox.propTypes = {
  id: PropTypes.string,
  checked: PropTypes.bool.isRequired,
  partiallyChecked: PropTypes.bool,
  onCheck: PropTypes.func.isRequired,
  disabled: PropTypes.bool
};

export default Checkbox;
